import VueLogger from 'vuejs-logger';
import Vue from 'vue';
import settings from './settings';

const options = {
  isEnabled: settings.logs,
  logLevel: 'debug',
  separator: '=>',
  showLogLevel: false,
  showMethodName: false,
};

Vue.use(VueLogger, options);
